/* eslint-disable prefer-const */
import axios from "axios";
import https from "https";
const win: any = window;

var token = win["clientToken"];
var reGenerateTokenUrl = win["reGenerateToken"];
var storeServerURL = win["storeServerURL"];
const cem_key = win["CEM_KEY"];
let config = {
  api: {
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    }),
    crossdomain: true,
    withCredentials: true,

    baseURL: process.env.REACT_APP_API,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",

      Authorization: "",
      "cem-key": cem_key,
    },
  },
};

export const api = axios.create({ ...config.api });

api.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  (error: any) => {
    if (
      (error.response.data.code && error.response.data.code === "APIGEE-001") ||
      (error.response.data.code && error.response.data.code === "APIGEE-002")
    ) {
      token = reGenerateToken(); // this is the one
      console.log(
        "in response error interceptors",
        JSON.stringify(error.response.config)
      );
      const { config: oldRequest } = error.response;

      return api.request({ ...oldRequest });
    }

    document.location.href = `/wps/portal/web/personal/store/error?errorSource=${
      window.lang === "en" ? "Store" : "المتجر"
    }`;
    return error;
  }
);

function reGenerateToken() {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + reGenerateTokenUrl);

  return new Promise((resolve, reject) => {
    fetch(storeServerURL + "" + reGenerateTokenUrl, {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
        "cem-key": cem_key,
      },
    })
      .then((res) => res.text())

      .then((result) => {
        //console.log("Token res -> "+result);
        resolve(result);
      })
      .catch((err) => {
        //console.log(err);
        reject(err);
      });
  });
}

api.interceptors.request.use(
  async (conf: any) => {
    conf.headers.Authorization = "Bearer " + token;
    conf.headers["cem-key"] = cem_key;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

export * from "./OrdersApi";
export * from "./OrdersApi/modals";
